export const CIRCULO_SUBTITLE_SEED = {
  fontFamily: 'Montserrat ExtraBold',
  fontSize: 50,
  textColor: '#111111',
  highlightBoxEnabled: false,
  highlightEnabled: true,
  textTransform: 'none' as const,
  shadowEnabled: false,
};

export function shouldSeedCirculoSubtitle(
  prevKind: string | null,
  nextKind: string,
): boolean {
  return nextKind === 'circulo' && prevKind !== 'circulo';
}
